import {actionTypeGenerator, stateGenerator} from "../utils";

export const INSTRUCTOR_DEMAND = actionTypeGenerator('instructorDemand');
export const INSTRUCTOR = actionTypeGenerator('instructor');
export const ORGANIZATION_CONNECTION = actionTypeGenerator('organizationConnection');
export const OUTGOING_ORGANIZATION_CONNECTION_DEMAND = actionTypeGenerator('outgoingOrganizationConnectionDemand');
export const INSTRUCTOR_ORGANIZATIONS_ALL = actionTypeGenerator('instructorOrganizationsAll');

let initialState = {
    demand: stateGenerator(true),
    original: stateGenerator(true),
    organizationConnection: stateGenerator(true),
    outgoingOrganizationConnectionDemand: stateGenerator(true),
};

export function instructor(state = initialState, action) {
    switch (action.type) {
        /** Demand resource  */
        case INSTRUCTOR_DEMAND.list.loading:
            return {
                ...state,
                demand: {
                    ...state.demand, data: null,
                    list: {...state.demand.list, isLoading: true}
                }
            };

        case INSTRUCTOR_DEMAND.loading:
            return {
                ...state,
                demand: {
                    ...state.demand,
                    isLoading: true
                }
            };

        case INSTRUCTOR_DEMAND.list.get:
            return {
                ...state,
                demand: {
                    ...state.demand,
                    list: {
                        ...state.demand.list,
                        data: action.payload.results,
                        count: action.payload.count,
                        isLoading: false
                    }
                }
            };

        case INSTRUCTOR_DEMAND.get:
            return {
                ...state,
                demand: {
                    ...state.demand,
                    data: action.payload, isLoading: false
                }
            };

        case INSTRUCTOR_DEMAND.create:
        case INSTRUCTOR_DEMAND.update:
            return {
                ...state,
                demand: {
                    ...state.demand,
                    data: action.payload, isLoading: false
                }
            };

        case INSTRUCTOR_DEMAND.list.error:
            return {
                ...state,
                demand: {
                    ...state.demand,
                    list: {...state.demand.list, error: action.payload, isLoading: false}
                }
            };


        case INSTRUCTOR_DEMAND.error:
            return {
                ...state,
                demand: {
                    ...state.demand,
                    error: action.payload, isLoading: false
                }
            };


        /** Instructor resource */
        case INSTRUCTOR.loading:
            return {
                ...state,
                original: {
                    ...state.original,
                    isLoading: true
                }
            };

        case INSTRUCTOR.get:
        case INSTRUCTOR.update:
            return {
                ...state,
                original: {
                    ...state.original,
                    data: action.payload, isLoading: false
                }
            };

        case INSTRUCTOR.error:
            return {
                ...state,
                original: {
                    ...state.original,
                    error: action.payload, isLoading: false
                }
            };

        /** Organization connection resource */
        case ORGANIZATION_CONNECTION.list.loading:
            return {
                ...state,
                organizationConnection: {
                    ...state.organizationConnection,
                    list: {
                        ...state.organizationConnection.list,
                        isLoading: true
                    }
                }
            };

        case ORGANIZATION_CONNECTION.loading:
            return {
                ...state,
                organizationConnection: {
                    ...state.organizationConnection,
                    isLoading: true
                }
            };

        case ORGANIZATION_CONNECTION.list.get:
            return {
                ...state,
                organizationConnection: {
                    ...state.organizationConnection,
                    list: {
                        ...state.organizationConnection.list,
                        data: action.payload.results,
                        count: action.payload.count,
                        isLoading: false
                    }
                }
            };

        case ORGANIZATION_CONNECTION.delete:
            return {
                ...state,
                organizationConnection: {
                    ...state.organizationConnection,
                    isLoading: false,
                    list: {
                        ...state.organizationConnection.list,
                        data: state.organizationConnection.list.data.filter(item => item.id !== action.payload),
                    }
                }
            };

        case ORGANIZATION_CONNECTION.list.error:
            return {
                ...state,
                organizationConnection: {
                    ...state.organizationConnection,
                    list: {...state.organizationConnection.list, error: action.payload, isLoading: false}
                }
            };

        case ORGANIZATION_CONNECTION.error:
            return {
                ...state,
                organizationConnection: {
                    ...state.organizationConnection,
                    error: action.payload, isLoading: false
                }
            };

        /** outgoing Organization Connection Demand */
        case OUTGOING_ORGANIZATION_CONNECTION_DEMAND.list.loading:
            return {
                ...state,
                outgoingOrganizationConnectionDemand: {
                    ...state.outgoingOrganizationConnectionDemand,
                    data: null,
                    list: {
                        ...state.outgoingOrganizationConnectionDemand.list,
                        isLoading: true
                    }
                }
            };

        case OUTGOING_ORGANIZATION_CONNECTION_DEMAND.loading:
            return {
                ...state,
                outgoingOrganizationConnectionDemand: {
                    ...state.outgoingOrganizationConnectionDemand,
                    isLoading: true
                }
            };

        case OUTGOING_ORGANIZATION_CONNECTION_DEMAND.list.get:
            return {
                ...state,
                outgoingOrganizationConnectionDemand: {
                    ...state.outgoingOrganizationConnectionDemand,
                    list: {
                        ...state.outgoingOrganizationConnectionDemand.list,
                        data: action.payload.results,
                        count: action.payload.count,
                        isLoading: false
                    }
                }
            };

        case OUTGOING_ORGANIZATION_CONNECTION_DEMAND.create:
            return {
                ...state,
                outgoingOrganizationConnectionDemand: {
                    ...state.outgoingOrganizationConnectionDemand,
                    data: action.payload,
                    isLoading: false,

                }
            };

        case OUTGOING_ORGANIZATION_CONNECTION_DEMAND.list.error:
            return {
                ...state,
                outgoingOrganizationConnectionDemand: {
                    ...state.outgoingOrganizationConnectionDemand,
                    list: {...state.outgoingOrganizationConnectionDemand.list, error: action.payload, isLoading: false}
                }
            };

        case OUTGOING_ORGANIZATION_CONNECTION_DEMAND.error:
            return {
                ...state,
                outgoingOrganizationConnectionDemand: {
                    ...state.outgoingOrganizationConnectionDemand,
                    error: action.payload, isLoading: false
                }
            };

        default:
            return state;

    }
}